import { create } from 'zustand';
import { clearAuthCookies, debugCookies } from '@/utils/cookieUtils';
import { WITHDRAW_BANK_INFO_STORAGE_KEY } from '@/config/storageKeys';

const useAuthStore = create((set) => ({
  accessToken: localStorage.getItem('accessToken'),
  user: null,
  justVerified: false,
  setAccessToken: (token, isVerification = false) => {
    localStorage.setItem('accessToken', token);
    set({ accessToken: token, justVerified: isVerification });
  },
  setUser: (user) => {
    set({ user });
  },
  clearJustVerified: () => {
    set({ justVerified: false });
  },
  clearAuth: () => {
    // Debug: Log cookies before clearing (only in development)
    if (process.env.NODE_ENV === 'development') {
      console.log('🔐 Clearing authentication...');
      debugCookies();
    }

    // Clear localStorage
    localStorage.removeItem('accessToken');
    localStorage.removeItem(WITHDRAW_BANK_INFO_STORAGE_KEY);

    // Clear authentication cookies (refresh_token, auth-token, etc.)
    clearAuthCookies();

    // Clear state
    set({ accessToken: null, user: null, justVerified: false });

    // Debug: Verify cookies are cleared (only in development)
    if (process.env.NODE_ENV === 'development') {
      setTimeout(() => {
        console.log('🔐 After clearing authentication:');
        debugCookies();
      }, 100);
    }
  },
}));

export default useAuthStore; 
